import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

// Import your slices
import { homeSlice } from "./Reducers/HomeSlice";
import { registrationSlice } from "./Reducers/registrationSlice";
import { meditationSlice } from "./Reducers/meditationSlice";
import {reflectionSlice} from "./Reducers/reflectionSlice";
import { coachSlice } from "./Reducers/CoachSlice";
import {coachRegistrationSlice} from "./Reducers/coachRegistrationSlice";

// Combine reducers
const rootReducer = combineReducers({
  homedata: homeSlice.reducer,
  registerUserdata: registrationSlice.reducer,
  meditationData: meditationSlice.reducer,
  reflectionData:reflectionSlice.reducer,
  coachData:coachSlice.reducer,
  coachregistrationData:coachRegistrationSlice.reducer
});

// Persist config
const persistConfig = {
  key: "root",
  storage: storage,
  // Optionally, you can blacklist or whitelist specific reducers
  // blacklist: ['meditationData'], // Reducers to exclude from persistence
  // whitelist: ['homedata', 'registerUserdata'], // Reducers to persist
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store
export const store = configureStore({
  reducer: persistedReducer,
  // Optionally, you can provide middleware, enhancers, etc.
  // middleware: [/* your middleware here */],
  // devTools: process.env.NODE_ENV !== 'production',
});

// Create a persistor object to persist the store
export const persistor = persistStore(store);
